import { post, get, del, put } from './requests'

export const getNonTasks = key =>
  get(['api', 'nonTask'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const createNonTask = key => payload =>
  post(
    ['api', 'nonTask'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const updateNonTask = key => (id, payload) =>
  put(
    ['api', 'nonTask', id],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const deleteNonTask = key => id =>
  del(['api', 'nonTask', id], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })



// WEBPACK FOOTER //
// ./src/services/non-tasks.js